import React from 'react'
import { Separator } from '@fs/zion-ui'
import AddNoteButton from '../../components/collaborate/AddNoteButton'
import { NotesSkeleton } from './NotesSkeleton'

export default function NotesCardContentSkeleton(): JSX.Element {
  return (
    <>
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <AddNoteButton disabled />
      <Separator size="nano" />
      <NotesSkeleton />
    </>
  )
}
